import { useState } from "react";
import { TabContext, TabList, TabPanel, AlertColor, Alert } from "@mui/lab";
import { Paper, Box, Tab } from "@mui/material";
import MasterKeyTable from "./MasterKeyTable";
import ICCardKeyTable from "./ICCardKeyTable";
import { FetchedData } from "./ContractorFormPage";

interface KeyTabsProps {
  fetchedData: FetchedData;
  isEnabled: boolean | undefined;
  fetchedAt: number;
  setSnackbarOpen: React.Dispatch<React.SetStateAction<boolean>>;
  setAlertSeverity: React.Dispatch<React.SetStateAction<AlertColor>>;
  setSnackbarMessage: React.Dispatch<React.SetStateAction<string>>;
}

const KeyTabs = ({
  fetchedData,
  isEnabled,
  fetchedAt,
  setSnackbarOpen,
  setAlertSeverity,
  setSnackbarMessage,
}: KeyTabsProps) => {
  const [tabValue, setTabValue] = useState("1");

  return (
    <>
      <Box sx={{ width: "100%", padding: 2 }} component={Paper}>
        <TabContext value={tabValue}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList
              onChange={(event, value) => setTabValue(value)}
              aria-label="lab API tabs example"
            >
              <Tab label="スマホキー" value="1" sx={{ typography: "body1" }} />
              <Tab
                label="ICカードキー"
                value="2"
                sx={{ typography: "body1" }}
              />
            </TabList>
          </Box>
          <TabPanel value="1">
            <MasterKeyTable
              buildingData={fetchedData.building}
              keysData={fetchedData.keys}
              isEnabled={isEnabled}
              canSetKeyExpiration={fetchedData.canSetKeyExpiration}
              setSnackbarOpen={setSnackbarOpen}
              setAlertSeverity={setAlertSeverity}
              setSnackbarMessage={setSnackbarMessage}
            />
          </TabPanel>
          <TabPanel value="2">
            <ICCardKeyTable
              buildingData={fetchedData.building}
              keysData={fetchedData.icCardKeys}
              fetchedAt={fetchedAt}
              isEnabled={isEnabled}
              setSnackbarOpen={setSnackbarOpen}
              setAlertSeverity={setAlertSeverity}
              setSnackbarMessage={setSnackbarMessage}
            />
          </TabPanel>
        </TabContext>
      </Box>
    </>
  );
};

export default KeyTabs;